<template>
    <loading v-if="loading"/>
    <div v-else>
      <div class="clickable px-2" v-for="aviso in avisos" :key="aviso.id" @click="goToObject(aviso)">
        <div class="px-2 pt-2">
          <font-awesome-icon icon="user"/>
          {{ aviso.fechaCreacion|fechaHora }}
        </div>
        <div class="px-2 font-weight-bold">
          {{ aviso.tipoObjetoTexto }}
        </div>
        <div class="px-2 border-bottom pb-2">
          <span v-html="aviso.descripcion"></span>
        </div>
      </div>
      <div v-if="avisos.length == 0" class="p-2">No hay avisos.</div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
export default {
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      avisosNuevos: 'avisosNuevos',
      avisosTodos: 'avisos',
      estados: 'estados',
      urlBase: 'urlBase'
    }),
    avisos() {
      if (this.todas) {
        return this.avisosTodos
      } else {
        return this.avisosNuevos
      }
    }

  },
  props: {
    todas: {
      default: false
    }
  },
  methods: {
    goToObject(aviso) {
      console.log(aviso)
      let to = {}
      switch(aviso.tipoObjeto) {
        case 1:
          to = { 'name': 'yo' }
          break;
        case 7:
          to = { 'name': 'poliza', params: { id: aviso.objeto }}
          break;
        case 10:
          to = { 'name': 'recibo', params: { id: aviso.objeto }}
          break;
        case 13:
          to = { 'name': 'siniestro', params: { id: aviso.objeto }}
          break;
        case 160:
          to = { 'name': 'proyecto', params: { id: aviso.objeto }}
          break;
      }
      this.opened = false
      this.$router.push(to)
        let url = this.urlBase + 'incidenciasClientes/' + aviso.id;
        let data = {
            situacion: 2
        };
        let options = {};
        this.$http.put(url, data, options).then(
          (response) => {
            console.log("OK")
            let payload = {
              params: {
                'sort': 'incidenciaCliente.fechaCreacion',
                'usuarioWebCliente': 1,
                'inverse': true,
                'page': 1,
                'limit': 100
              },
              callbackOk: (responses) => {
                this.loading = false
              }
            }
            this.$store.dispatch("loadAvisos", payload)
          },
          (error) => {
          }
        )
    }
  },
  components: {
    Loading
  }
}
</script>
